/* FDP Instagram Block carousel
 *
 * Each carousel is initialized from its own section wrapper so multiple
 * Instagram Block sections can coexist without sharing a Swiper instance,
 * pending modal state, or click handlers.
 */
(function (window, document) {
  'use strict';

  var existingApi = window.FDPInstagramBlock;

  if (existingApi) {
    existingApi.initAll(document);
    return;
  }

  var api = {};
  window.FDPInstagramBlock = api;

  function safePlay(video) {
    if (!video || typeof video.play !== 'function') return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Browsers can reject programmatic autoplay. The next user interaction
        // can still start the thumbnail video.
      });
    }
  }

  function getActiveSlide(swiper) {
    return swiper && swiper.slides ? swiper.slides[swiper.activeIndex] : null;
  }

  function loadThumbnailVideo(slide) {
    if (!slide) return;

    var background = slide.querySelector('.instagram-block__background-photo[data-video]');
    if (!background) return;

    var videoUrl = background.getAttribute('data-video');
    var videoLoad = background.querySelector('.video-load');

    if (!videoUrl || !videoLoad) return;

    var video = videoLoad.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.src = videoUrl;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      videoLoad.appendChild(video);
    }
  }

  function removeModals(carousel) {
    var modals = carousel.querySelectorAll('.youtube-video-modal');

    Array.prototype.forEach.call(modals, function (modal) {
      modal.remove();
    });
  }

  function openModal(carousel, slide, youtubeId, videoFull) {
    if (!slide || (!youtubeId && !videoFull)) return;

    // Keep modal cleanup local to this carousel. The original document-wide
    // selector would close a modal belonging to a second Instagram section.
    removeModals(carousel);

    if (slide.querySelector('.youtube-video-modal')) return;

    var modal = document.createElement('div');
    modal.className = 'youtube-video-modal';

    var closeButton = document.createElement('button');
    closeButton.className = 'close-modal';
    closeButton.innerHTML = '<span></span>';
    closeButton.onclick = function (event) {
      event.stopPropagation();
      modal.remove();
    };
    modal.appendChild(closeButton);

    if (youtubeId) {
      var isVerticalVideo = slide.classList.contains('vertical-video');
      var iframe = document.createElement('iframe');

      iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?autoplay=1&si=';
      iframe.title = 'YouTube video player';
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.width = isVerticalVideo ? '720' : '1280';
      iframe.height = isVerticalVideo ? '1280' : '720';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      modal.appendChild(iframe);
    } else if (videoFull) {
      var video = document.createElement('video');
      video.src = videoFull;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = true;
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'contain';
      modal.appendChild(video);
      safePlay(video);
    }

    slide.appendChild(modal);
  }

  function hydrateImages(carousel) {
    var images = carousel.querySelectorAll('img[datasrc]');

    Array.prototype.forEach.call(images, function (image) {
      image.setAttribute('src', image.getAttribute('datasrc'));
      image.removeAttribute('datasrc');
    });
  }

  function initialiseViewportChecker(carousel) {
    var jQuery = window.jQuery;

    if (!jQuery || !jQuery.fn || !jQuery.fn.viewportChecker) {
      hydrateImages(carousel);
      return;
    }

    jQuery(function () {
      jQuery(carousel).viewportChecker({
        offset: -500,
        callbackFunction: function (element) {
          // viewportChecker provides a jQuery collection, while image
          // hydration intentionally works with the native carousel element.
          hydrateImages(element && element.jquery ? element[0] : element);
        }
      });
    });
  }

  function initialiseSection(section) {
    if (!section || section.getAttribute('data-fdp-instagram-block-initialized') === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    var carousel = section.querySelector('[data-instagram-block-carousel]');
    if (!carousel) return;

    section.setAttribute('data-fdp-instagram-block-initialized', 'true');

    var swiper = new window.Swiper(carousel, {
      speed: 600,
      grabCursor: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      slideToClickedSlide: true,
      initialTransitionCount: 0,
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: false
      },
      on: {
        beforeTransitionStart: function () {
          loadThumbnailVideo(getActiveSlide(this));
        },
        sliderFirstMove: function () {
          // Retained for parity with the original carousel event configuration.
        },
        slideChange: function () {
          removeModals(carousel);
        },
        transitionStart: function () {
          var videos = carousel.querySelectorAll('video');

          Array.prototype.forEach.call(videos, function (video) {
            video.pause();
          });
        },
        transitionEnd: function () {
          this.initialTransitionCount += 1;

          var activeSlide = getActiveSlide(this);
          var activeSlideVideo = activeSlide && activeSlide.querySelector('video');
          if (activeSlideVideo) {
            removeModals(carousel);
            safePlay(activeSlideVideo);
          }

          // Retain the original active-slide click callback. It is intentionally
          // scoped to this carousel so multiple section instances stay isolated.
          var innerDiv = activeSlide && activeSlide.querySelector('.instagram-block__review-item > div');
          if (innerDiv) {
            innerDiv.click();
          }

          // Preserve the original recentering behaviour for the looped Swiper.
          this.slideToLoop(this.realIndex, 400);
        },
        slideChangeTransitionEnd: function () {
          var pendingYoutubeId = carousel.getAttribute('data-pending-youtube-id');
          var pendingVideoFull = carousel.getAttribute('data-pending-video-full');

          if (pendingYoutubeId || pendingVideoFull) {
            carousel.removeAttribute('data-pending-youtube-id');
            carousel.removeAttribute('data-pending-video-full');
            openModal(carousel, getActiveSlide(this), pendingYoutubeId, pendingVideoFull);
          }
        }
      }
    });

    swiper.initialTransitionCount = 0;
    section._fdpInstagramBlockSwiper = swiper;

    swiper.on('init', function () {
      swiper.update();
      swiper.slideToLoop(swiper.activeIndex, 0);
    });

    carousel.addEventListener('click', function (event) {
      if (swiper.animating) return;

      var background = event.target.closest('.instagram-block__background-photo[data-youtube-id], .instagram-block__background-photo[data-video-full]');
      if (!background || !carousel.contains(background)) return;
      if (event.target.closest('.youtube-video-modal, .close-modal')) return;

      var youtubeId = background.getAttribute('data-youtube-id') || '';
      var videoFull = background.getAttribute('data-video-full') || '';
      if (!youtubeId && !videoFull) return;

      var currentSlide = background.closest('.swiper-slide');
      // The existing markup provides this one-based value. This preserves the
      // prior slideToLoop behaviour while keeping it inside this section.
      var index = parseInt(currentSlide.getAttribute('data-video-slide-index'), 10) || 0;

      if (currentSlide.classList.contains('swiper-slide-active')) {
        openModal(carousel, currentSlide, youtubeId, videoFull);
      } else {
        carousel.setAttribute('data-pending-youtube-id', youtubeId);
        carousel.setAttribute('data-pending-video-full', videoFull);
        swiper.slideToLoop(index);
      }
    });

    initialiseViewportChecker(carousel);

    window.setTimeout(function () {
      if (!swiper.destroyed) swiper.update();
    }, 100);
  }

  api.initSection = initialiseSection;
  api.initAll = function (scope) {
    var root = scope || document;
    var sections = [];

    if (root.matches && root.matches('[data-instagram-block-section]')) {
      sections.push(root);
    }

    Array.prototype.push.apply(sections, root.querySelectorAll('[data-instagram-block-section]'));
    Array.prototype.forEach.call(sections, initialiseSection);
  };

  api.initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    api.initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches('[data-instagram-block-section]')
      ? event.target
      : event.target.querySelector('[data-instagram-block-section]');
    var swiper = section && section._fdpInstagramBlockSwiper;

    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
  });
})(window, document);